<template>
  <div>
    <div class="ad-field">
      <van-field v-model="addrInfo.name" name="就诊人" label="就诊人" placeholder="就诊人"
                 :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field readonly clickable name="picker" :value="addrInfo.sexName" label="性别" placeholder="请选择"
                 @click="showSexList= true"/>
      <van-popup v-model="showSexList" position="bottom">
          <van-picker title="性别" show-toolbar :columns="sexList" @confirm="afterSelSex"
                      @cancel="showSexList= false" />
      </van-popup>
      <van-field v-model="addrInfo.id" name="身份证号" label="身份证号" placeholder="身份证号"
                 :rules="[{ required: true, message: '请填写身份证号' }]" />
      <van-field v-model="addrInfo.age" name="年龄" label="年龄" placeholder="年龄"
                 :rules="[{ required: true, message: '请填写年龄' }]" />
      <van-field v-model="addrInfo.mobile" name="手机" label="手机" placeholder="手机"
                 :rules="[{ required: true, message: '请填写手机号码' }]" />

<!--      <van-field readonly clickable name="area" :value="addrInfo.cityName" label="地区选择"-->
<!--                 placeholder="点击选择省市区" @click="showCity = true" />-->
<!--      <van-popup v-model="showCity" position="bottom">-->
<!--        <van-area :area-list="areaList" @confirm="afterSelCity" @cancel="showCity = false" />-->
<!--      </van-popup>-->

      <van-field v-model="addrInfo.address" name="详细地址" label="详细地址" placeholder="详细地址"
                 type="textarea" autosize rows="2"
                 :rules="[{ required: true, message: '请填写详细地址' }]" />
    </div>

    <div class="ad-function">
      <van-button type="primary" block round @click="postAddress">保存地址</van-button>
    </div>
  </div>
</template>

<script setup>
import {customerBussiness} from "@/service/MpServer";

export default {
  components: { },

  name: 'CusDocBook',
  data() {
    return {
      isWinXinClient: false,
      showSexList: false,
      //showCity:false,
      addrInfo:{},

      sexList:[{text: "男", value:"0"},{text: "女", value:"1"}],
      areaList:[]
    }
  },

  mounted() {
    let _this= this;
    _this.addrInfo= {name:"", sex:"", id:"", age:"0", mobile:"", city:"", key:"", address:""};
    if (_this.$route.query.address){
      let info= JSON.parse(_this.$route.query.address);
      _this.addrInfo= {
        name: info.NAME,
        sex: info.SEX,
        sexName: info.SEX=="0"? "男": "女",
        id: info.ID,
        age: info.AGE,
        mobile:info.MOBILE,
        city:info.CITY_NAME,
        key:info.CUSTOMER_ADDRESS_ID,
        address:info.ADDRESS
      }
    }
  },

  methods: {
    getCityList(){
      let _this= this;
      let param = {  };
      _this.areaList= [];
      // customerBussiness( "CUSTOMER", "getWCity", param, function (data) {
      //   let ProvTable = JSON.parse(data).Table;
      //   let jsonProv= {};
      //   for(let prov of ProvTable) {
      //     _this.$set(jsonProv, prov.VALUE_CODE, prov.VALUE_NAME);
      //   }
      //
      //   }
      // })
    },

    afterSelSex(value, index){
      this.addrInfo.sexName= value.text;
      this.addrInfo.sex= value.value;
      this.showSexList = false;
    },

    afterSelCity(value, index){
      this.addrInfo.cityName= value.text;
      this.addrInfo.city= value.value;
      this.showCity = false;
    },

    postAddress(){
      if (this.addrInfo.name== ""){
        this.$toast('就诊人不能为空!');
        return;
      }
      if (this.addrInfo.sex== ""){
        this.$toast('性别不能为空!');
        return;
      }
      if (this.addrInfo.id== ""){
        this.$toast('身份证号不能为空!');
        return;
      }
      if (this.addrInfo.id.length!= 18){
        this.$toast('身份证号长度必需18位!');
        return;
      }

      if (this.addrInfo.age== ""){
        this.$toast('年龄不能为空!');
        return;
      }
      if (this.addrInfo.mobile== ""){
        this.$toast('手机不能为空!');
        return;
      }

      let _this= this;
      let param = { name:this.addrInfo.name, sex:this.addrInfo.sex, id:_this.addrInfo.id, age:_this.addrInfo.age,
        moble:_this.addrInfo.mobile, city:"", key:_this.addrInfo.key, addr:_this.addrInfo.address};
      param= {srcData: JSON.stringify(param)};
      customerBussiness( "CUSTOMER_WECHAT", "postWAddress", param, function (data) {
        _this.$toast("保存成功！");
        _this.$router.go(-1);
      });
    }
  }
}
</script>

<style scoped lang="less">

</style>
